import React, { useState, useEffect } from 'react';
import DashboardDonutChart from '../DashboardDonutChart';
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import moment from 'moment';
import * as DashboardUtils from '../DashboardUtils.js';
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'

const DonutCharts = (props) => {
  const [executionStatisticsData, setExecutionStatisticsData] = useState([]);
  const [executionClassificationsData, setExecutionClassificationsData] = useState([]);
  const [executionStatisticsLoading, setExecutionStatisticsLoading] = useState(false);
  const [executionClassificationsLoading, setExecutionClassificationsLoading] = useState(false);

  useEffect(() => {
    getAggregationStatics(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    getExceptionClassification(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
  }, [props.preferencesChanged]);

  const prepareDonutChartData = (response) => {
    let data = [];
    let buckets = response.aggregations["automata status"].buckets;
    let total = 0;
    if (buckets.length) {
      for (let i = 0; i < buckets.length; i++) {
        total = total + buckets[i].count.value;
      }
      for (let i = 0; i < buckets.length; i++) {
        data[i] = {
          'group': buckets[i].key,
          'value': buckets[i].count.value,
          'percentage': ((buckets[i].count.value * 100) / total).toFixed(2),
          'chartItems': [{
            'title': DashboardConstants.Total,
            'value': buckets[i].count.value
          }]
        }
      }
    }
    return data;
  }

  const prepareclassificationData = (response) => {
    let data = [];
    let buckets = response.aggregations.count_all.buckets;
    let total = 0;
    if (buckets.length) {
      for (let i = 0; i < buckets.length; i++) {
        total = total + buckets[i]["1"].value;
      }
      for (let i = 0; i < buckets.length; i++) {
        data[i] = {
          'group': buckets[i].key,
          'value': buckets[i]["1"].value,
          'percentage': ((buckets[i]["1"].value * 100) / total).toFixed(2),
          'chartItems': [{
            'title': DashboardConstants.Total,
            'value': buckets[i]["1"].value
          }]
        }
      }
    }
    return data;
  }

  const getAggregationStatics = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
      setExecutionStatisticsLoading(true);
      let formattedData = [];
      let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
      let timeZone = moment.tz.guess();
      let technology;
      let franchise;
      let client;
      let bodyJSON;

      if (workspace === workspaces.automation_ops) {
        technology = dashboardFilterSelectionsAutomation.technology;
        franchise = dashboardFilterSelectionsAutomation.franchise;
        client = dashboardFilterSelectionsAutomation.client;
        bodyJSON = {
          "filters": {
            "time": {
              "startDateTime": timeFilterSelections.startDateTime,
              "endDateTime": timeFilterSelections.endDateTime
            },
            "franchises": franchise,
            "clients": client,
            "technologies": technology,
            "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
            "geos": dashboardFilterSelectionsAutomation.geo,
            "automata_state": dashboardFilterSelectionsAutomation.automata_state,
            "business_competencies": dashboardFilterSelectionsAutomation.competency,
            "buisness_component": dashboardFilterSelectionsAutomation.buisness_component,
            "automata_priority": dashboardFilterSelectionsAutomation.priority,
            "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
            "resource": dashboardFilterSelectionsAutomation.resource   
          },
          "interval": {
            "calender_Interval": calenderInterval,
            "time_zone": timeZone
          },
          "workspace": workspace
        };
      }

      callPostApi(Constants.GETAGGREGATIONSTATICS, {
        'Content-Type': 'application/json'
      }, bodyJSON)
        .then(resp => {
          formattedData = prepareDonutChartData(resp);
          setExecutionStatisticsData(formattedData);
          setExecutionStatisticsLoading(false);
        }).catch((error) => {
          setExecutionStatisticsLoading(false);
          console.error('Error:', error);
        });

    }
  }

  const getExceptionClassification = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
      setExecutionClassificationsLoading(true);
      let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
      let timeZone = moment.tz.guess();
      let formattedData = [];
      let technology;
      let franchise;
      let client;
      let bodyJSON;

      if (workspace === workspaces.automation_ops) {
        technology = dashboardFilterSelectionsAutomation.technology;
        franchise = dashboardFilterSelectionsAutomation.franchise;
        client = dashboardFilterSelectionsAutomation.client;
        bodyJSON = {
          "filters": {
            "time": {
              "startDateTime": timeFilterSelections.startDateTime,
              "endDateTime": timeFilterSelections.endDateTime
            },
            "franchises": franchise,
            "clients": client,
            "technologies": technology,
            "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
            "geos": dashboardFilterSelectionsAutomation.geo,
            "automata_state": dashboardFilterSelectionsAutomation.automata_state,
            "business_competencies": dashboardFilterSelectionsAutomation.competency,
            "buisness_component": dashboardFilterSelectionsAutomation.buisness_component,
            "automata_priority": dashboardFilterSelectionsAutomation.priority,
            "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
            "resource": dashboardFilterSelectionsAutomation.resource   
          },
          "interval": {
            "calender_Interval": calenderInterval,
            "time_zone": timeZone
          },
          "workspace": workspace
        };
      }

      callPostApi(Constants.GETEXCEPTIONCLASSIFICATION, {
        'Content-Type': 'application/json'
      }, bodyJSON)
        .then(resp => {
          formattedData = prepareclassificationData(resp);
          setExecutionClassificationsData(formattedData);
          setExecutionClassificationsLoading(false);
        }).catch((error) => {
          console.error('Error:', error);
          setExecutionClassificationsLoading(false);
        });

    }
  }
  return (
    <div className="donut-chart">
      <div>
        <DashboardDonutChart donutChartData={executionStatisticsData} title={DashboardConstants.ExeStatistics} loading={executionStatisticsLoading} />
      </div>
      <div>
        <DashboardDonutChart donutChartData={executionClassificationsData} title={DashboardConstants.ExeClassifications} loading={executionClassificationsLoading} />
      </div>
    </div>
  );
}

export default DonutCharts
